import { useQuery } from '@tanstack/react-query';
import {
  AppointmentNotificationPreference,
  Condition,
  Practitioner,
} from 'src/models';
import { api } from 'src/services/api';
import { UseQueryOverrideOptions } from '../common';

type UseGetPractitionerNotificationPreferencesParams = {
  practitionerId: Practitioner['practitioner_id'];
  conditionId: Condition['id'];
};

type GetPractitionerNotificationPreferencesResponse = {
  response: {
    mute_notifications: boolean;
    send_practitioner_emails: null;
    preferences: {
      notification_preference: AppointmentNotificationPreference[];
      emails: string[];
    };
  };
};

export const useGetPractitionerNotificationPreferences = (
  params: UseGetPractitionerNotificationPreferencesParams,
  options: UseQueryOverrideOptions = {}
) => {
  const { practitionerId, conditionId } = params;
  return useQuery({
    ...options,
    queryKey: ['practitionerNotificationPreferences', params],
    queryFn: () => {
      return api
        .post<GetPractitionerNotificationPreferencesResponse>(
          '/notification_preference',
          {
            practitioner_id: practitionerId,
            condition_id: conditionId,
          }
        )
        .then((res) => res.data?.response);
    },
  });
};
